/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemCodeResponse
 */
export interface RedeemCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RedeemCodeResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedeemCodeResponse
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemCodeResponse
     */
    milestoneComplete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemCodeResponse
     */
    questComplete?: boolean;
}

/**
 * Check if a given object implements the RedeemCodeResponse interface.
 */
export function instanceOfRedeemCodeResponse(value: object): value is RedeemCodeResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RedeemCodeResponseFromJSON(json: any): RedeemCodeResponse {
    return RedeemCodeResponseFromJSONTyped(json, false);
}

export function RedeemCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'milestoneComplete': json['milestoneComplete'] == null ? undefined : json['milestoneComplete'],
        'questComplete': json['questComplete'] == null ? undefined : json['questComplete'],
    };
}

export function RedeemCodeResponseToJSON(json: any): RedeemCodeResponse {
    return RedeemCodeResponseToJSONTyped(json, false);
}

export function RedeemCodeResponseToJSONTyped(value?: RedeemCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'milestoneComplete': value['milestoneComplete'],
        'questComplete': value['questComplete'],
    };
}

